// extracted by mini-css-extract-plugin
module.exports = {"Round":"Round_Round__3PeA6","Selections":"Round_Selections__1oZUw","Background":"Round_Background__etUNU"};